import { Tabs } from "antd";
import { useState } from "react";
import { useHistory, useParams } from "react-router";
import "../../../project-setting-menu/module-settings/module-settings.scss";
import DesignScopeLevelOfDetailSettings from "pages/project-setting-menu/module-settings/design-scope-settings/design-scope-level-of-detail-settings";
import BootstrapDesignScopeSettings from "../bootstrap-design-scope";

function DesignScopeSubscriptionSettings() {
  const history = useHistory();
  const { tab3Id } = useParams() as any;
  const [selectedTab, setSelectedTab] = useState<string>(tab3Id || "bootstrap");

  const tabItems = [
    {
      label: (
        <span className="pl-2.5" data-testid="bootstrap-design-scope-tab">
          Design Scope List
        </span>
      ),
      key: "bootstrap",
      children: <BootstrapDesignScopeSettings />
    },
    {
      label: (
        <span className="pl-2.5" data-testid="design-scope-level-of-detail-tab">
          Level of Detail
        </span>
      ),
      key: "level-of-detail",
      children: (
        <DesignScopeLevelOfDetailSettings
          disabled={false}
          scope="subscription"
        />
      )
    }
  ];

  return (
    <div className="w-full bg-ciq-white h-full module-settings--tabs">
      <Tabs
        tabPlacement="start"
        tabBarGutter={2}
        tabBarStyle={{ width: "220px" }}
        activeKey={selectedTab}
        items={tabItems}
        onChange={(activeKey) => {
          history.push(`/settings/modules/designscope/${activeKey.toString()}`);
          setSelectedTab(activeKey);
        }}
        destroyOnHidden
      />
    </div>
  );
}

export default DesignScopeSubscriptionSettings;
